document.documentElement.classList.add('js');

const animatedItems = document.querySelectorAll('[data-animate]');

if ('IntersectionObserver' in window) {
  const animationObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        animationObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  animatedItems.forEach((item) => animationObserver.observe(item));
} else {
  animatedItems.forEach((item) => item.classList.add('is-visible'));
}

document.querySelectorAll('[data-carousel]').forEach((carousel) => {
  const slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
  const dots = Array.from(carousel.querySelectorAll('[data-carousel-dot]'));
  const prevButton = carousel.querySelector('[data-carousel-prev]');
  const nextButton = carousel.querySelector('[data-carousel-next]');
  const pauseButton = carousel.querySelector('[data-carousel-pause]');
  const currentCounter = carousel.querySelector('[data-carousel-current]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const autoplay = carousel.dataset.autoplay === 'true' && !reduceMotion;
  const interval = Number.parseInt(carousel.dataset.interval, 10) || 6000;
  let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
  let timer;
  let paused = false;
  let temporarilyPaused = false;

  if (activeIndex < 0) activeIndex = 0;

  const setSlide = (nextIndex) => {
    if (!slides.length) return;
    activeIndex = (nextIndex + slides.length) % slides.length;

    slides.forEach((slide, index) => {
      const isActive = index === activeIndex;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      slide.toggleAttribute('inert', !isActive);

      slide.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((control) => {
        if (isActive) {
          if (control.dataset.carouselTabindex !== undefined) {
            const previousTabindex = control.dataset.carouselTabindex;
            if (previousTabindex) {
              control.setAttribute('tabindex', previousTabindex);
            } else {
              control.removeAttribute('tabindex');
            }
            delete control.dataset.carouselTabindex;
          }
        } else {
          if (control.dataset.carouselTabindex === undefined) {
            control.dataset.carouselTabindex = control.getAttribute('tabindex') || '';
          }
          control.setAttribute('tabindex', '-1');
        }
      });
    });

    dots.forEach((dot, index) => {
      const isActive = index === activeIndex;
      dot.classList.toggle('is-active', isActive);
      dot.toggleAttribute('aria-current', isActive);
    });

    if (currentCounter) currentCounter.textContent = String(activeIndex + 1);
  };

  const stopTimer = () => {
    if (timer) window.clearInterval(timer);
    timer = undefined;
  };

  const startTimer = () => {
    stopTimer();
    if (autoplay && !paused && !temporarilyPaused && slides.length > 1 && !document.hidden) {
      timer = window.setInterval(() => setSlide(activeIndex + 1), interval);
    }
  };

  const suspendTimer = () => {
    temporarilyPaused = true;
    stopTimer();
  };

  const restoreTimer = () => {
    temporarilyPaused = false;
    startTimer();
  };

  const userAdvance = (nextIndex) => {
    paused = true;
    if (pauseButton) {
      pauseButton.setAttribute('aria-pressed', 'true');
      pauseButton.textContent = pauseButton.dataset.resumeText || 'Resume';
    }
    stopTimer();
    setSlide(nextIndex);
  };

  prevButton?.addEventListener('click', () => userAdvance(activeIndex - 1));
  nextButton?.addEventListener('click', () => userAdvance(activeIndex + 1));

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      userAdvance(Number.parseInt(dot.dataset.carouselDot, 10) || 0);
    });
  });

  carousel.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      userAdvance(activeIndex - 1);
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault();
      userAdvance(activeIndex + 1);
    }
  });

  carousel.addEventListener('mouseenter', suspendTimer);
  carousel.addEventListener('mouseleave', restoreTimer);
  carousel.addEventListener('focusin', suspendTimer);
  carousel.addEventListener('focusout', (event) => {
    if (!carousel.contains(event.relatedTarget)) restoreTimer();
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      stopTimer();
    } else {
      startTimer();
    }
  });

  if (pauseButton) {
    pauseButton.dataset.pauseText = pauseButton.textContent;
    pauseButton.dataset.resumeText = pauseButton.getAttribute('data-resume-text') || 'Resume';
    pauseButton.addEventListener('click', () => {
      paused = !paused;
      pauseButton.setAttribute('aria-pressed', paused ? 'true' : 'false');
      pauseButton.textContent = paused ? pauseButton.dataset.resumeText : pauseButton.dataset.pauseText;
      if (paused) {
        stopTimer();
      } else {
        startTimer();
      }
    });
  }

  setSlide(activeIndex);
  startTimer();
});

document.querySelectorAll('[data-blog-carousel]').forEach((carousel) => {
  const track = carousel.querySelector('[data-blog-track]');
  const prevButton = carousel.querySelector('[data-blog-prev]');
  const nextButton = carousel.querySelector('[data-blog-next]');

  if (!track) return;

  const scrollByCard = (direction) => {
    const card = track.querySelector('.blog-preview__card');
    const gap = Number.parseFloat(window.getComputedStyle(track).columnGap) || 18;
    const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.85;
    track.scrollBy({ left: direction * distance, behavior: 'smooth' });
  };

  prevButton?.addEventListener('click', () => scrollByCard(-1));
  nextButton?.addEventListener('click', () => scrollByCard(1));
});

document.querySelectorAll('[data-editorial-rail]').forEach((rail) => {
  const track = rail.querySelector('[data-editorial-track]');
  const previousButton = rail.querySelector('[data-editorial-prev]');
  const nextButton = rail.querySelector('[data-editorial-next]');
  const products = track ? Array.from(track.querySelectorAll('.editorial-collection__product')) : [];
  let pendingIndex = null;
  let settleTimer;

  if (!track) return;

  const productLeft = (product) => {
    const trackRect = track.getBoundingClientRect();
    const productRect = product.getBoundingClientRect();
    return track.scrollLeft + productRect.left - trackRect.left;
  };

  const nearestProductIndex = () => {
    if (!products.length) return 0;

    return products.reduce((nearestIndex, product, index) => (
      Math.abs(productLeft(product) - track.scrollLeft)
        < Math.abs(productLeft(products[nearestIndex]) - track.scrollLeft)
        ? index
        : nearestIndex
    ), 0);
  };

  const updateControls = () => {
    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    if (previousButton) previousButton.disabled = track.scrollLeft <= 2;
    if (nextButton) nextButton.disabled = track.scrollLeft >= maxScroll - 2;
  };

  const scrollByProduct = (direction) => {
    if (!products.length) return;

    const currentIndex = pendingIndex ?? nearestProductIndex();
    const nextIndex = Math.max(0, Math.min(currentIndex + direction, products.length - 1));
    pendingIndex = nextIndex;

    track.scrollTo({
      left: productLeft(products[nextIndex]),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });

    window.clearTimeout(settleTimer);
    settleTimer = window.setTimeout(() => {
      pendingIndex = null;
      updateControls();
    }, 420);
  };

  previousButton?.addEventListener('click', () => scrollByProduct(-1));
  nextButton?.addEventListener('click', () => scrollByProduct(1));
  track.addEventListener('scroll', updateControls, { passive: true });
  window.addEventListener('resize', updateControls, { passive: true });
  updateControls();
});

let heldProductCard;

const releaseHeldProductCard = () => {
  heldProductCard?.classList.remove('is-held');
  heldProductCard = undefined;
};

document.addEventListener('pointerdown', (event) => {
  if (event.pointerType === 'mouse' && event.button !== 0) return;

  const productCard = event.target.closest('[data-product-rail] .product-card');
  if (!productCard) return;

  releaseHeldProductCard();
  heldProductCard = productCard;
  heldProductCard.classList.add('is-held');
}, { passive: true });

document.addEventListener('pointerup', releaseHeldProductCard, { passive: true });
document.addEventListener('pointercancel', releaseHeldProductCard, { passive: true });
window.addEventListener('blur', releaseHeldProductCard);

const ambientMotionLayers = document.querySelectorAll('[data-ambient-motion]');

if (ambientMotionLayers.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  if ('IntersectionObserver' in window) {
    const ambientShadowObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('is-active', entry.isIntersecting);
      });
    }, { rootMargin: '120px 0px' });

    ambientMotionLayers.forEach((layer) => ambientShadowObserver.observe(layer));
  } else {
    ambientMotionLayers.forEach((layer) => layer.classList.add('is-active'));
  }
}

const ambientVideos = document.querySelectorAll('[data-ambient-video]');
const ambientVideoMotionAllowed = !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  && !navigator.connection?.saveData;

if (ambientVideos.length) {
  const playAmbientVideo = (video) => {
    const carouselSlide = video.closest('[data-carousel-slide]');
    if (!ambientVideoMotionAllowed || document.hidden || (carouselSlide && !carouselSlide.classList.contains('is-active'))) {
      video.pause();
      return;
    }

    video.play().catch(() => {
      // The original campaign image remains visible if autoplay is unavailable.
    });
  };

  if (!ambientVideoMotionAllowed) {
    ambientVideos.forEach((video) => {
      video.hidden = true;
      video.pause();
    });
  } else if ('IntersectionObserver' in window) {
    const ambientVideoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.toggleAttribute('data-in-view', entry.isIntersecting);
        if (entry.isIntersecting) {
          playAmbientVideo(entry.target);
        } else {
          entry.target.pause();
        }
      });
    }, { rootMargin: '160px 0px' });

    ambientVideos.forEach((video) => ambientVideoObserver.observe(video));

    document.querySelectorAll('[data-carousel]').forEach((carousel) => {
      const carouselVideoObserver = new MutationObserver(() => {
        carousel.querySelectorAll('[data-ambient-video][data-in-view]').forEach(playAmbientVideo);
      });
      carouselVideoObserver.observe(carousel, { attributes: true, subtree: true, attributeFilter: ['class'] });
    });

    document.addEventListener('visibilitychange', () => {
      ambientVideos.forEach((video) => {
        if (video.hasAttribute('data-in-view')) {
          playAmbientVideo(video);
        } else {
          video.pause();
        }
      });
    });
  } else {
    ambientVideos.forEach(playAmbientVideo);
  }
}

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const track = gallery.querySelector('[data-product-gallery-track]');
  const slides = Array.from(gallery.querySelectorAll('[data-product-gallery-slide]'));
  const dots = Array.from(gallery.querySelectorAll('[data-product-gallery-dot]'));
  const previousButton = gallery.querySelector('[data-product-gallery-previous]');
  const nextButton = gallery.querySelector('[data-product-gallery-next]');
  const currentPosition = gallery.querySelector('[data-product-gallery-current]');
  let activeIndex = 0;
  let scrollFrame;

  if (!track || slides.length < 2) return;

  const setActiveIndex = (nextIndex) => {
    activeIndex = Math.max(0, Math.min(nextIndex, slides.length - 1));

    dots.forEach((dot, index) => {
      const isActive = index === activeIndex;
      dot.classList.toggle('is-active', isActive);
      if (isActive) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });

    if (currentPosition) currentPosition.textContent = String(activeIndex + 1);
    if (previousButton) previousButton.disabled = activeIndex === 0;
    if (nextButton) nextButton.disabled = activeIndex === slides.length - 1;
  };

  const goToSlide = (nextIndex) => {
    const clampedIndex = Math.max(0, Math.min(nextIndex, slides.length - 1));
    track.scrollTo({
      left: slides[clampedIndex].offsetLeft,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
    setActiveIndex(clampedIndex);
  };

  previousButton?.addEventListener('click', () => goToSlide(activeIndex - 1));
  nextButton?.addEventListener('click', () => goToSlide(activeIndex + 1));
  dots.forEach((dot) => {
    dot.addEventListener('click', () => goToSlide(Number.parseInt(dot.dataset.productGalleryDot, 10) || 0));
  });

  track.addEventListener('scroll', () => {
    if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
    scrollFrame = window.requestAnimationFrame(() => {
      const slideWidth = track.clientWidth || 1;
      setActiveIndex(Math.round(track.scrollLeft / slideWidth));
    });
  }, { passive: true });

  gallery.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      goToSlide(activeIndex - 1);
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      goToSlide(activeIndex + 1);
    }
  });

  setActiveIndex(0);
});

document.querySelectorAll('[data-shopping-assistant]').forEach((assistant) => {
  const prompt = assistant.querySelector('[data-assistant-prompt]');
  const openers = assistant.querySelectorAll('[data-assistant-open]');
  const closeButtons = assistant.querySelectorAll('[data-assistant-close]');
  const messageFocusButtons = assistant.querySelectorAll('[data-assistant-focus-message]');
  const panel = assistant.querySelector('[data-assistant-panel]');
  const toggle = assistant.querySelector('[data-assistant-toggle]');
  const dismissalKey = 'kreateur-assistance-prompt-dismissed';
  const shownKey = 'kreateur-assistance-prompt-shown';
  let returnFocus;

  try {
    if (window.sessionStorage.getItem(dismissalKey) === 'true') {
      prompt?.setAttribute('hidden', '');
    } else if (window.sessionStorage.getItem(shownKey) !== 'true') {
      window.setTimeout(() => {
        if (!assistant.hasAttribute('open')) {
          prompt?.removeAttribute('hidden');
          window.sessionStorage.setItem(shownKey, 'true');
        }
      }, 8000);
    }
  } catch (error) {
    window.setTimeout(() => prompt?.removeAttribute('hidden'), 8000);
  }

  const openAssistant = () => {
    returnFocus = document.activeElement;
    assistant.setAttribute('open', '');
    prompt?.setAttribute('hidden', '');
    panel?.removeAttribute('hidden');
    toggle?.setAttribute('aria-expanded', 'true');
    panel?.querySelector('button, a, input, textarea')?.focus();
  };

  const closeAssistant = () => {
    assistant.removeAttribute('open');
    panel?.setAttribute('hidden', '');
    toggle?.setAttribute('aria-expanded', 'false');
    if (returnFocus instanceof HTMLElement) returnFocus.focus();
  };

  openers.forEach((button) => button.addEventListener('click', openAssistant));
  messageFocusButtons.forEach((button) => button.addEventListener('click', () => {
    openAssistant();
    assistant.querySelector('#AssistantMessage')?.focus();
  }));
  closeButtons.forEach((button) => button.addEventListener('click', () => {
    if (button.hasAttribute('data-assistant-dismiss')) {
      prompt?.setAttribute('hidden', '');
      try {
        window.sessionStorage.setItem(dismissalKey, 'true');
      } catch (error) {
        // Dismissal still works for this page when storage is unavailable.
      }
      return;
    }
    closeAssistant();
  }));

  assistant.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAssistant();

    if (event.key === 'Tab' && !panel?.hasAttribute('hidden')) {
      const focusable = Array.from(panel.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });
});

document.querySelectorAll('[data-mobile-menu-toggle]').forEach((toggle) => {
  const targetId = toggle.getAttribute('aria-controls');
  const menu = targetId ? document.getElementById(targetId) : null;
  const closeLabel = toggle.dataset.closeLabel || 'Close menu';
  const openLabel = toggle.dataset.openLabel || 'Menu';
  const label = toggle.querySelector('[data-mobile-menu-label]');
  const setLabel = (value) => {
    if (label) {
      label.textContent = value;
    } else {
      toggle.textContent = value;
    }
  };

  if (!menu) return;

  toggle.addEventListener('click', () => {
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    setLabel(isOpen ? openLabel : closeLabel);
    menu.toggleAttribute('data-open', !isOpen);
  });

  menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
    toggle.setAttribute('aria-expanded', 'false');
    setLabel(openLabel);
    menu.removeAttribute('data-open');
  }));

  window.matchMedia('(min-width: 1400px)').addEventListener('change', (event) => {
    if (!event.matches) return;
    toggle.setAttribute('aria-expanded', 'false');
    setLabel(openLabel);
    menu.removeAttribute('data-open');
  });
});

const navigationGroups = Array.from(document.querySelectorAll('[data-nav-group]'));

navigationGroups.forEach((group) => {
  group.addEventListener('toggle', () => {
    if (!group.open) return;
    navigationGroups.forEach((otherGroup) => {
      if (otherGroup !== group) otherGroup.open = false;
    });
  });

  group.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    group.open = false;
    group.querySelector('summary')?.focus();
  });
});

document.addEventListener('click', (event) => {
  navigationGroups.forEach((group) => {
    if (!group.contains(event.target)) group.open = false;
  });
});

document.querySelectorAll('[data-promotion-countdown]').forEach((countdown) => {
  const endTime = Date.parse(countdown.dataset.promotionEnd || '');
  const threshold = Number.parseInt(countdown.dataset.promotionThreshold, 10) || 86400000;
  let timer;

  const updateCountdown = () => {
    const remaining = endTime - Date.now();

    if (!Number.isFinite(endTime) || remaining <= 0 || remaining > threshold) {
      countdown.setAttribute('hidden', '');
      if (remaining <= 0 && timer) window.clearInterval(timer);
      return;
    }

    const hours = Math.floor(remaining / 3600000);
    const minutes = Math.floor((remaining % 3600000) / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);
    countdown.textContent = `Ends in ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    countdown.removeAttribute('hidden');
  };

  updateCountdown();
  timer = window.setInterval(updateCountdown, 1000);
});

const productFactLabels = {
  'approximate dimensions': { key: 'dimensions', label: 'Dimensions' },
  dimensions: { key: 'dimensions', label: 'Dimensions' },
  size: { key: 'dimensions', label: 'Dimensions' },
  'lot weight': { key: 'weight', label: 'Lot weight' },
  'total weight': { key: 'weight', label: 'Lot weight' },
  'approximate weight': { key: 'weight', label: 'Weight' },
  weight: { key: 'weight', label: 'Weight' },
  material: { key: 'material', label: 'Material' },
  stone: { key: 'material', label: 'Material' },
  finish: { key: 'finish', label: 'Finish' },
  'approximate piece count': { key: 'piece-count', label: 'Approx. count' },
  'piece count': { key: 'piece-count', label: 'Piece count' },
  'pieces included': { key: 'piece-count', label: 'Pieces included' },
  selection: { key: 'selection', label: 'Selection' },
  'selection method': { key: 'selection', label: 'Selection' },
  'lot type': { key: 'selection', label: 'Lot type' },
  'best for': { key: 'best-for', label: 'Best for' },
  form: { key: 'form', label: 'Form' },
  care: { key: 'care', label: 'Care' }
};

const parseProductFacts = (source) => {
  if (!source) return [];
  const facts = new Map();
  const elements = Array.from(source.querySelectorAll('li, p'));
  let context = '';
  const textWithLineBreaks = (element) => {
    const clone = element.cloneNode(true);
    clone.querySelectorAll('br').forEach((breakElement) => breakElement.replaceWith('\n'));
    return clone.textContent || '';
  };

  elements.forEach((element) => {
    const lines = textWithLineBreaks(element)
      .split(/\n|\r|\s*[•·]\s*|(?=\s[*-]\s+)/)
      .map((line) => line.replace(/^[\s*-]+/, '').trim())
      .filter(Boolean);
    const metricParts = [];

    lines.forEach((line) => {
      const match = line.match(/^([^:]{2,42}):\s*(.+)$/);
      if (!match) return;
      const rawLabel = match[1].trim();
      const normalizedLabel = rawLabel.toLowerCase().replace(/[’']/g, '');
      const value = match[2].trim();
      const metricLabel = {
        height: 'Height',
        width: 'Width',
        length: 'Length',
        depth: 'Depth',
        'approx. weight': 'Weight',
        'approx weight': 'Weight'
      }[normalizedLabel];

      if (metricLabel && value.length <= 80) {
        metricParts.push(`${metricLabel}: ${value}`);
        return;
      }

      const definition = productFactLabels[normalizedLabel];
      if (!definition || !value || value.length > 220 || facts.has(definition.key)) return;
      facts.set(definition.key, { ...definition, value });
    });

    if (metricParts.length) {
      const contextualLabel = context && !/^(approximate\s+)?dimensions?$/i.test(context)
        ? context
        : 'Dimensions';
      const contextualKey = `dimensions-${contextualLabel.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')}`;
      if (!facts.has(contextualKey)) {
        facts.set(contextualKey, {
          key: contextualKey,
          label: contextualLabel,
          value: metricParts.join('; ')
        });
      }
    }

    if (
      lines.length === 1
      && lines[0].length <= 64
      && !lines[0].includes(':')
      && !/[.!?]$/.test(lines[0])
    ) {
      context = lines[0];
    }
  });

  const plainText = (source.innerText || source.textContent || '')
    .replace(/\u00a0/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  const addNaturalFact = (key, label, value, maxLength = 120) => {
    const cleanedValue = value
      ?.split(/[•·\n\r]/, 1)[0]
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/[.;,]+$/, '');
    if (
      !cleanedValue
      || cleanedValue.length > maxLength
      || /(?:https?:\/\/|www\.)/i.test(cleanedValue)
      || Array.from(facts.keys()).some((factKey) => factKey === key || factKey.startsWith(`${key}-`))
    ) return;
    facts.set(key, { key, label, value: cleanedValue });
  };

  const materialMatch = plainText.match(/\bmade (?:from|of|with)\s+([^,.;•·\n\r]{2,80})/i);
  if (materialMatch) addNaturalFact('material', 'Material', materialMatch[1], 80);

  const selectionMatch = plainText.match(/\bavailable as\s+([^.;•·\n\r]{3,120})/i);
  if (selectionMatch) addNaturalFact('selection', 'Options', selectionMatch[1], 120);

  const bestForMatch = plainText.match(/\bideal for\s+([^.;•·\n\r]{3,120})/i);
  if (bestForMatch) addNaturalFact('best-for', 'Best for', bestForMatch[1], 120);

  const includedMatch = plainText.match(/\bset of\s+((?:one|two|three|four|five|\d+)[^.;•·\n\r]{0,70})/i);
  if (includedMatch) addNaturalFact('piece-count', 'Included', includedMatch[1], 80);

  const minimumPieceMatch = plainText.match(/\bminimum\s+([~≈]?\s*\d+(?:\.\d+)?\s*(?:lb|lbs|pounds?|oz|ounces?)\s+per piece(?:\s*\([^)]{1,60}\))?)/i);
  if (minimumPieceMatch) addNaturalFact('piece-size', 'Piece size', minimumPieceMatch[1], 100);

  const largePieceMatch = plainText.match(/\bmay include very large specimens\s*\(([^)]{2,60})\)/i);
  if (largePieceMatch) addNaturalFact('largest-pieces', 'Possible larger pieces', largePieceMatch[1], 60);

  const finishMixMatch = plainText.match(/\bmix of\s+((?:rough|polished|semi-polished)[^.;•·]{3,100}?pieces)\b/i);
  if (finishMixMatch) addNaturalFact('finish', 'Finish mix', finishMixMatch[1], 100);

  if (/\b(?:strictly\s+)?no selection\b/i.test(plainText)) {
    addNaturalFact('selection', 'Selection', 'No individual selection; each lot is unique', 80);
  }

  const shippingMatch = plainText.match(/\borders may ship in\s+([^.;•·\n\r]{3,100})/i);
  if (shippingMatch) addNaturalFact('shipping', 'Shipping', shippingMatch[1], 100);

  if (/\ball sales are final\b/i.test(plainText)) {
    addNaturalFact('returns', 'Returns', 'Final sale', 40);
  }

  return Array.from(facts.values());
};

const formatMoney = (cents, currency) => {
  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency
    }).format(cents / 100);
  } catch (error) {
    return `$${(cents / 100).toFixed(2)}`;
  }
};

document.querySelectorAll('[data-product-root]').forEach((productRoot) => {
  const variantData = productRoot.querySelector('[data-product-variants]');
  const variantSelect = productRoot.querySelector('[data-variant-select]');
  const currentPrice = productRoot.querySelector('[data-current-price]');
  const comparePrice = productRoot.querySelector('[data-compare-price]');
  const saleLabel = productRoot.querySelector('[data-sale-label]');
  const savings = productRoot.querySelector('[data-savings]');
  const availability = productRoot.querySelector('[data-availability]');
  const availabilityFaq = productRoot.querySelector('[data-faq-availability]');
  const addToCart = productRoot.querySelector('[data-add-to-cart]');
  const unitPrice = productRoot.querySelector('[data-unit-price]');
  const promotionRegular = productRoot.querySelector('[data-promotion-regular]');
  const promotionPrice = productRoot.querySelector('[data-promotion-price]');
  const factsList = productRoot.querySelector('[data-product-facts]');
  const descriptionSource = productRoot.querySelector('[data-product-description-source]');
  const faqList = productRoot.querySelector('[data-product-faq-list]');
  const faqSchema = productRoot.querySelector('[data-product-faq-schema]');
  const currency = productRoot.dataset.currency || 'USD';
  const showUnitPrice = productRoot.dataset.showUnitPrice === 'true';
  const productI18n = {
    available: productRoot.dataset.i18nAvailable || 'Available',
    soldOut: productRoot.dataset.i18nSoldOut || 'Sold out',
    addToCart: productRoot.dataset.i18nAddToCart || 'Add to cart',
    unitPrice: productRoot.dataset.i18nUnitPrice || '__PRICE__ per lb',
    unitPriceLabel: productRoot.dataset.i18nUnitPriceLabel || 'Price per lb',
    availabilityFaq: productRoot.dataset.i18nAvailabilityFaq || '__TITLE__ is __STATUS__ in the selected option. Availability is confirmed again before it can be added to cart.',
    currentlyAvailable: productRoot.dataset.i18nCurrentlyAvailable || 'currently available',
    currentlySoldOut: productRoot.dataset.i18nCurrentlySoldOut || 'currently sold out'
  };
  const promotionActive = productRoot.dataset.promotionActive === 'true';
  const promotionPercent = Number.parseInt(productRoot.dataset.promotionPercent, 10) || 0;
  let variants = [];
  let facts = [];

  try {
    variants = JSON.parse(variantData?.textContent || '[]');
  } catch (error) {
    variants = [];
  }

  const addFact = (fact) => {
    if (!factsList || factsList.querySelector(`[data-fact-key="${fact.key}"]`)) return;
    const row = document.createElement('div');
    row.dataset.factKey = fact.key;
    const term = document.createElement('dt');
    const definition = document.createElement('dd');
    term.textContent = fact.label;
    definition.textContent = fact.value;
    row.append(term, definition);
    factsList.append(row);
  };

  facts = parseProductFacts(descriptionSource);
  const titlePieceCount = productRoot.dataset.productTitle?.match(/\b(\d+)[-\s]?piece\b/i);
  if (titlePieceCount && !facts.some((fact) => fact.key === 'piece-count')) {
    facts.push({ key: 'piece-count', label: 'Piece count', value: `${titlePieceCount[1]} pieces` });
  }
  facts.forEach(addFact);

  const weightForVariant = (variant) => {
    const variantWeight = variant?.title?.match(/(\d+(?:\.\d+)?)\s*(?:lb|lbs|pounds?)\b/i);
    if (variantWeight) return Number.parseFloat(variantWeight[1]);
    const titleWeight = productRoot.dataset.productTitle?.match(/(\d+(?:\.\d+)?)\s*(?:lb|lbs|pounds?)\b/i);
    if (titleWeight) return Number.parseFloat(titleWeight[1]);
    const weightFact = facts.find((fact) => fact.key === 'weight');
    const factWeight = weightFact?.value.match(/(\d+(?:\.\d+)?)\s*(?:lb|lbs|pounds?)\b/i);
    return factWeight ? Number.parseFloat(factWeight[1]) : null;
  };

  const updateFaqSchema = () => {
    if (!faqSchema || !faqList) return;
    const entities = Array.from(faqList.querySelectorAll('details')).map((details) => ({
      '@type': 'Question',
      name: details.querySelector('summary')?.textContent.trim() || '',
      acceptedAnswer: {
        '@type': 'Answer',
        text: details.querySelector('p')?.textContent.trim() || ''
      }
    })).filter((entity) => entity.name && entity.acceptedAnswer.text);
    faqSchema.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: entities
    });
  };

  const appendFactFaqs = () => {
    if (!faqList) return;
    const fillTemplate = (template, replacements) => Object.entries(replacements)
      .reduce((result, [placeholder, value]) => result.replaceAll(placeholder, value), template);
    const faqDefinitions = {
      dimensions: (fact) => [productRoot.dataset.i18nFaqDimensionsQuestion, fillTemplate(productRoot.dataset.i18nFaqDimensionsAnswer, { __VALUE__: fact.value })],
      weight: (fact) => [productRoot.dataset.i18nFaqWeightQuestion, fillTemplate(productRoot.dataset.i18nFaqWeightAnswer, { __VALUE__: fact.value })],
      'piece-size': (fact) => [productRoot.dataset.i18nFaqPieceSizeQuestion, fillTemplate(productRoot.dataset.i18nFaqPieceSizeAnswer, { __VALUE__: fact.value })],
      'largest-pieces': (fact) => [productRoot.dataset.i18nFaqLargestPiecesQuestion, fillTemplate(productRoot.dataset.i18nFaqLargestPiecesAnswer, { __VALUE__: fact.value })],
      'piece-count': (fact) => [productRoot.dataset.i18nFaqPieceCountQuestion, fillTemplate(productRoot.dataset.i18nFaqPieceCountAnswer, { __VALUE__: fact.value })],
      selection: (fact) => [productRoot.dataset.i18nFaqSelectionQuestion, fillTemplate(productRoot.dataset.i18nFaqSelectionAnswer, { __VALUE__: fact.value })],
      material: (fact) => [productRoot.dataset.i18nFaqMaterialQuestion, fillTemplate(productRoot.dataset.i18nFaqMaterialAnswer, { __VALUE__: fact.value })],
      shipping: (fact) => [productRoot.dataset.i18nFaqShippingQuestion, fillTemplate(productRoot.dataset.i18nFaqShippingAnswer, { __VALUE__: fact.value })],
      returns: (fact) => [productRoot.dataset.i18nFaqReturnsQuestion, fillTemplate(productRoot.dataset.i18nFaqReturnsAnswer, { __VALUE__: fact.value.toLowerCase() })]
    };

    facts.forEach((fact) => {
      const definition = faqDefinitions[fact.key]
        || (fact.key.startsWith('dimensions-')
          ? (dimensionFact) => [
              fillTemplate(productRoot.dataset.i18nFaqLabeledDimensionsQuestion, { __LABEL__: dimensionFact.label }),
              fillTemplate(productRoot.dataset.i18nFaqLabeledDimensionsAnswer, { __LABEL__: dimensionFact.label, __VALUE__: dimensionFact.value })
            ]
          : null);
      if (!definition || faqList.querySelector(`[data-faq-key="${fact.key}"]`)) return;
      const [question, answer] = definition(fact);
      const details = document.createElement('details');
      details.dataset.faqKey = fact.key;
      const summary = document.createElement('summary');
      const paragraph = document.createElement('p');
      summary.textContent = question;
      paragraph.textContent = answer;
      details.append(summary, paragraph);
      faqList.insertBefore(details, faqList.lastElementChild);
    });

    updateFaqSchema();
  };

  appendFactFaqs();

  const updateVariant = (variantId) => {
    const variant = variants.find((item) => String(item.id) === String(variantId)) || variants[0];
    if (!variant) return;
    const onSale = Number(variant.compareAtPrice) > Number(variant.price);
    const price = Number(variant.price) || 0;
    const compareAt = Number(variant.compareAtPrice) || 0;

    if (currentPrice) {
      currentPrice.textContent = formatMoney(price, currency);
      currentPrice.classList.toggle('main-product__price--sale', onSale);
    }
    if (comparePrice) {
      comparePrice.textContent = onSale ? formatMoney(compareAt, currency) : '';
      comparePrice.toggleAttribute('hidden', !onSale);
    }
    saleLabel?.toggleAttribute('hidden', !onSale);
    if (savings) {
      savings.textContent = onSale ? `You save ${formatMoney(compareAt - price, currency)}` : '';
      savings.toggleAttribute('hidden', !onSale);
    }
    if (availability) availability.textContent = variant.available ? productI18n.available : productI18n.soldOut;
    if (availabilityFaq) {
      availabilityFaq.textContent = productI18n.availabilityFaq
        .replace('__TITLE__', document.querySelector('h1')?.textContent.trim() || '')
        .replace('__STATUS__', variant.available ? productI18n.currentlyAvailable : productI18n.currentlySoldOut);
    }
    if (addToCart) {
      addToCart.disabled = !variant.available;
      addToCart.textContent = variant.available ? productI18n.addToCart : productI18n.soldOut;
    }

    const weightLb = weightForVariant(variant);
    if (unitPrice && showUnitPrice) {
      if (weightLb && weightLb > 0) {
        const pricePerLb = price / weightLb;
        unitPrice.textContent = productI18n.unitPrice.replace('__PRICE__', formatMoney(Math.round(pricePerLb), currency));
        unitPrice.removeAttribute('hidden');
        const unitFact = { key: 'unit-price', label: productI18n.unitPriceLabel, value: formatMoney(Math.round(pricePerLb), currency) };
        const existingUnitFact = factsList?.querySelector('[data-fact-key="unit-price"] dd');
        if (existingUnitFact) {
          existingUnitFact.textContent = unitFact.value;
        } else {
          addFact(unitFact);
        }
      } else {
        unitPrice.setAttribute('hidden', '');
        factsList?.querySelector('[data-fact-key="unit-price"]')?.remove();
      }
    }

    if (promotionActive && promotionPercent > 0) {
      const promotionalPrice = Math.round(price * (100 - promotionPercent) / 100);
      if (promotionRegular) promotionRegular.textContent = formatMoney(price, currency);
      if (promotionPrice) promotionPrice.textContent = formatMoney(promotionalPrice, currency);
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
    updateFaqSchema();
  };

  variantSelect?.addEventListener('change', (event) => updateVariant(event.target.value));
  updateVariant(variantSelect?.value || variants[0]?.id);
});
